import { createLoginRoute, REFERRER_QUERY_PARAM } from '@/utils/routing'

import ApiRequest from '@/services/ApiRequests/ApiRequest'
import PortalApi from '@/services/Api/PortalApi'
import Admin from '@/models/Admin'

export default ({ store, redirect }) => {
  if (store.getters['admin/admin'] == null) {
    return new ApiRequest(PortalApi.getCurrentAdmin, Admin).execute()
      .then((admin) => store.dispatch('admin/setAdmin', admin))
      .catch(() => {
        store.dispatch('admin/setAdmin', null)
        redirect(createLoginRoute({ query: { [REFERRER_QUERY_PARAM]: window.location.href } }))
      })
  }
}
